import React, { useState, useEffect } from 'react';
import {
    API_ADD_LOAN_REPAYMENT,
    API_CENTERS,
    API_GET_CLIENTS,
    API_GET_REPAYMENT_PAID
} from '../Config/ApiUrlConstant'; // Import your constants
import { useAuth } from '../AuthContext'; // Import useAuth hook for access

const branches = [
    {
        "id": 1,
        "Branch_no": "BRAN0001",
        "branch_name": "Mohanw"
    }
];

const employeeList = [
    {
        "id": 1,
        "emp_generate_id": "EMP0001",
        "emp_name": "Awadhesh Kumar"
    },
    {
        "id": 2,
        "emp_generate_id": "EMP0002",
        "emp_name": "Manohar Kumar"
    },

];
const LoanRepayment = () => {
    const { logout } = useAuth(); // Add this at the top inside the component

    const [formData, setFormData] = useState({
        branch_id: "",
        center_id: "",
        client_id: "",
        installment_no: "",
        installment_amt: "",
        repayment_paid_by_staff: "",
        is_closure: 0, // Default to 0,        
        created_at: null
    });
    const [clients, setClients] = useState([]);
    const [centerList, setCenterList] = useState([]);
    const [lastInstallmentNo, setLastInstallmentNo] = useState('');
    const numbers = Array.from({ length: 26 }, (_, index) => index + 1);
    const token = localStorage.getItem('token');

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(' name->', name, ' && value->', value)
        if (name == "client_id") {
            const findData = clients.find((client) => client.id == value)
            console.log(' findData->', findData)
            if (findData) {
                setFormData({
                    ...formData,
                    ['installment_amt']: formData.is_closure ? parseInt(findData.remaining_principal_amt) : (parseInt(findData.remaining_principal_amt) > 0 ? parseInt(findData.cycle_installment_amt) : parseInt(findData.remaining_principal_amt)),
                    ['client_id']: findData.id,
                })
            } else {
                setFormData({
                    ...formData,
                    ['client_id']: '',
                })
            }
        } else if (name == 'is_closure') {
            const findData = clients.find((client) => client.id == formData.client_id)
            console.log("findData 70->", findData)
            if (findData) {
                setFormData({
                    ...formData,
                    [name]: e.target.checked ? 1 : 0,
                    ['installment_amt']: e.target.checked ? parseInt(findData.remaining_principal_amt) : (parseInt(findData.remaining_principal_amt) > 0 ? parseInt(findData.cycle_installment_amt) : parseInt(findData.remaining_principal_amt)),
                    ['client_id']: findData.id,
                });
            } else {
                setFormData({
                    ...formData,
                    [name]: e.target.checked ? 1 : 0,
                });
            }

        } else {
            if (name == 'branch_id' && value != "") {
                getCentersByBranch(value);
            } else if (name == 'branch_id' && value == "") {
                setCenterList([])
                setClients([])
                resetForm();
            } else if (name == 'center_id' && value == "") {
                setClients([])
            }
            setFormData({
                ...formData,
                [name]: value,
            });
        }

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle form submission (could be an API call or other action)
        console.log('formData ->', formData)
        // API call to submit the form data
        try {
            const response = await fetch(API_ADD_LOAN_REPAYMENT, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify(formData),
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const result = await response.json();
            console.log(result)
            if (result && result.loanRepaymentId && result.loanRepaymentId.affectedRows > 0) {
                console.log(result);
                resetForm();
                alert(result.message)
            } else {
                alert(result.message)
            }
        } catch (error) {
            alert("An error occurred. Please try again.");
            console.error(error);
        }
    };

    const getCentersByBranch = async (branchId) => {
        if (branchId) {
            try {
                const response = await fetch(API_CENTERS, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',  // Add Content-Type header
                        'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                    },
                    body: JSON.stringify({ is_all: false, branch_id: branchId })  // Serialize the body to JSON
                });
                if (response.status === 401 || response.status === 403) {
                    logout(); // 👈 Token invalid or expired → logout
                    return;
                }
                const responseData = await response.json(); // Parse JSON response
                // console.log('responseData ->', responseData)
                setCenterList(responseData.data)
            } catch (error) {
                console.error('Error:', error);
                setCenterList([])
            }
        }else{
            setCenterList([])
            resetForm();
        }
    }

    const getClients = async () => {
        // API call to submit the form data
        if (formData.center_id) {
            try {
                const response = await fetch(API_GET_CLIENTS, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',  // Add Content-Type header
                        'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                    },
                    body: JSON.stringify({
                        center_id: formData.center_id,
                        is_all: 0
                    }),
                });
                if (response.status === 401 || response.status === 403) {
                    logout(); // 👈 Token invalid or expired → logout
                    return;
                }
                // console.log('response->', response)
                const result = await response.json();
                setClients(result.data)
            } catch (error) {
                alert("An error occurred. Please try again.");
                console.error(error);
            }
        }
    }
    const getInstallmentPaid = async () => {
        // API call to submit the form data
        if (formData.client_id) {
            try {
                const response = await fetch(API_GET_REPAYMENT_PAID, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',  // Add Content-Type header
                        'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                    },
                    body: JSON.stringify({
                        branch_id: formData.branch_id,
                        center_id: formData.center_id,
                        client_id: formData.client_id,
                    }),
                });
                if (response.status === 401 || response.status === 403) {
                    logout(); // 👈 Token invalid or expired → logout
                    return;
                }
                const result = await response.json();
                // console.log('getInstallmentPaid result ->', result.data.installment_no)
                if (result && result.data && result.data.installment_no) {
                    setLastInstallmentNo(result.data.installment_no);
                } else {
                    setLastInstallmentNo(0);
                }
            } catch (error) {
                alert("An error occurred. Please try again.");
                console.error(error);
            }
        }
    }
    const resetForm = () => {
        setFormData({
            ...formData,
            branch_id: "",
            center_id: "",
            client_id: "",
            installment_no: "",
            installment_amt: "",
            repayment_paid_by_staff: "",
            is_closure: 0, // Default to 0
            created_at: ""
        });
    }
    // Example useEffect with multiple dependencies in formData
    useEffect(() => {
        // console.log('formData changed:', formData);
        if (formData.center_id && !formData.client_id) {
            // console.log('Fetching clients for center_id:', formData.center_id);
            getClients();  // Call the function to fetch clients
        }
        else if (formData.client_id && formData.center_id) {
            // console.log('Fetching installment data for client_id:', formData.client_id);
            getInstallmentPaid();  // Call the function to fetch installment paid data
        }
    }, [formData.center_id, formData.client_id, formData.branch_id]);



    return (
        <div className="container my-5">
            <h2 className="text-center">Loan Repayment Form</h2>
            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="is_closure"
                                name="is_closure"
                                checked={formData.is_closure === 1}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="is_closure" style={{ marginLeft: "10px", paddingTop: "3px" }}>
                                Is full settlement?
                            </label>
                        </div>
                        <div>
                            <small className={`text-${formData.is_closure ? 'success' : 'secondary'}`}>
                                {formData.is_closure ? "Marked as full settlement." : "Not marked for full settlement."}
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* Branch Name */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="branch_id" className="form-label">Branch Name</label>
                            <select
                                className="form-control"
                                name="branch_id"
                                value={formData.branch_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="" >Select Branch </option>
                                {branches.map(branch => (
                                    <option key={branch.id} value={branch.id}>
                                        {branch.branch_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Center Name */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="center_id" className="form-label">Center Name</label>
                            <select
                                className="form-control"
                                name="center_id"
                                value={formData.center_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="" >Select Center</option>
                                {centerList.map(center => (
                                    <option key={center.id} value={center.id}>
                                        {center.center_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Client Name */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="client_id" className="form-label">Client Name</label>
                            <select
                                className="form-control"
                                name="client_id"
                                value={formData.client_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="" >Select Client</option>
                                {clients.map(client => (
                                    <option key={client.id} value={client.id}>
                                        {client.client_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Installment No */}
                    {formData.is_closure == 0 &&
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label htmlFor="installment_no" className="form-label">Installment No (1-26)</label>
                                <select
                                    className="form-control"
                                    name="installment_no"
                                    value={formData.installment_no}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Installment</option>
                                    {numbers.map((number) => {
                                        console.log(number, ' && ', parseInt(lastInstallmentNo))
                                        if (lastInstallmentNo && number > parseInt(lastInstallmentNo)) {
                                            return (
                                                <option key={number} value={number}>
                                                    {number}
                                                </option>
                                            )
                                        }
                                        else if (parseInt(lastInstallmentNo) == 0) {

                                            return (
                                                <option key={number} value={number}>
                                                    {number}
                                                </option>
                                            )

                                        }
                                    })}
                                </select>
                            </div>
                        </div>
                    }
                </div>

                <div className="row">
                    {/* Installment Amount */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="installment_amt" className="form-label">Installment Amount</label>
                            <input
                                type="number"
                                id="installAmt"
                                className="form-control"
                                value={formData.installment_amt}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    {/* Repayment Paid by Staff */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="repayment_paid_by_staff" className="form-label">Repayment Paid by Staff</label>
                            <select
                                className="form-control"
                                name="repayment_paid_by_staff"
                                value={formData.repayment_paid_by_staff}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select staff</option>
                                {employeeList.map(employee => (
                                    <option key={employee.id} value={employee.id}>
                                        {employee.emp_generate_id}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="created_at" className="form-label">Repayment Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="created_at"
                                value={formData.created_at}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                </div>


                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Submit</button>
                </div>
            </form>
        </div>
    );
};

export default LoanRepayment;